import { render, staticRenderFns } from "./files-list.vue?vue&type=template&id=789e1c31&scoped=true"
import script from "./files-list.vue?vue&type=script&lang=js"
export * from "./files-list.vue?vue&type=script&lang=js"
import style0 from "./files-list.vue?vue&type=style&index=0&id=789e1c31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789e1c31",
  null
  
)

export default component.exports